import { join } from 'ramda';

export const joinWithNonBreakingSpace = join('\u00a0');
